import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

// let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache({
//         addTypename: false,
//         resultCaching: false
//     }),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });


export async function getCampaignPricesList(params: any) {
    const GET_CAMPAIGN_PRICES = gql`
    query{
        campaignPriceGroupBy(by:utmCampaign, sortOrder:Asc)
        {
            utmCampaign
            items{
                id
            }
        }
    }
    `;
    return client.query({
        query: GET_CAMPAIGN_PRICES,
        variables: {
            skip: params.pagination.perPage * (params.pagination.page - 1),
            take: params.pagination.perPage,
        }
    })
}